// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  border: 1px solid #505257;
  border-radius: 10px;
  padding: 6px 12px;
  width: 700px;
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(30px);
  background: rgba(34, 34, 34, 0.7);
  box-shadow: 14px 9px 9px 0px rgba(0, 0, 0, 0.49);

  svg,
  p {
    color: #9fa8ac;
  }

  svg {
    transform: scale(1.1);
    margin-bottom: -4px;
  }

  p {
    font-size: 32px;
    margin-bottom: 2px;
  }

  @media (max-width: 992px) {
    margin-top: -150px;
  }
`;
